export const config = {
	api_url: "https://react-saas.herokuapp.com"
}